import { createSelector } from '@reduxjs/toolkit';

import { getSharedTextFieldCaps } from 'editor/src/store/design/util/sharedTextFields';
import { RootState } from 'editor/src/store/index';

/**
 * Every group's operative character cap, by id, computed once per design.
 *
 * `resolveSharedTextField` answers the same question for one element, but it
 * walks the whole design to do it — fine inside an operation, wasteful in a
 * `useSelector`, where each shared text on the current spread would repeat the
 * walk on every store change, design-touching or not. The cap of a group
 * depends on nothing but the design and the group's id, so one memoized pass
 * serves every reader of it.
 *
 * A group with no capped member has no entry, exactly as
 * `resolveSharedTextField` reports `undefined` for one — the two are the same
 * filter and must stay so, which is what `getSharedTextFieldCaps` is for.
 */
const getSharedTextFieldCapsSelector = createSelector(
  [(state: RootState) => state.design.designData],
  getSharedTextFieldCaps,
);

export default getSharedTextFieldCapsSelector;
